"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONLY_LATIN_ALPHABET_EMAIL_REGEX = exports.PREVIEW_URL = exports.DATE_FORMAT = exports.CURRENCIES = exports.BUILDING_MEDIA_TYPES = exports.MEDIA_TYPES = exports.PROFILE_LINKS = exports.POST_STATUSES = exports.PROPERTY_TYPES = exports.DEAL_TYPES = exports.ROLES = exports.GENERAL_SETTINGS = exports.MESSENGERS = void 0;
exports.MESSENGERS = {
    VIBER: 'viber',
    WHATSAPP: 'whatsapp',
    TELEGRAM: 'telegram',
};
exports.GENERAL_SETTINGS = {
    CONTACT_PHONE: {
        FORMATED: '044 500-900',
        PHONE_NUMBER: '+37444500900',
        MESSENGERS: [
            exports.MESSENGERS.VIBER,
            exports.MESSENGERS.WHATSAPP,
            exports.MESSENGERS.TELEGRAM,
        ],
    },
    EMAIL: 'info@banali.am',
    APP_NAME: 'banali',
    SOCIAL_LINKS: [
        {
            icon: 'facebook icon',
            url: 'https://www.facebook.com/www.banali.am ', //"https://www.facebook.com/Banaliam-113575180020413" ???
        },
        {
            icon: 'instagram icon',
            url: 'https://www.instagram.com/banali.am/',
        },
        {
            icon: 'youtube icon',
            url: 'https://www.youtube.com/channel/UChfy0YTfk9HOzd1LEDCCIUA',
        },
        {
            icon: 'viber icon',
            url: 'viber://chat?number=%2B37444500900',
        },
        {
            icon: 'telegram icon',
            url: 'https://t.me/banali_am',
        },
        {
            icon: 'whatsapp icon',
            url: 'https://api.whatsapp.com/send/?phone=%2B37444500900&text&type=phone_number&app_absent=0',
        },
        {
            icon: 'facebook messenger icon',
            url: 'https://www.messenger.com/t/www.banali.am',
        },
        {
            icon: 'linkedin icon',
            url: 'https://www.linkedin.com/company/banali-am/',
        },
    ],
    // determines what layout to show on mobile
    SEARCH_MOBILE_LAYOUT: 'postView',
    FILTERS: {
        DEFAULT_VALUE: { deal: 'sell' },
        IGNORE_ON_COUNT: ['deal'],
    },
    PLANS: {
        BASIC: 'basic',
        PREMIUM: 'premium',
        VIP: 'vip',
        TOUR_3D: 'tour_3d',
        PIN_TO_TOP: 'pin_to_top',
    },
};
exports.ROLES = {
    INDIVIDUAL: 'individual',
    DEVELOPER: 'developer',
};
exports.DEAL_TYPES = {
    RENT: 'rent',
    SELL: 'sell',
};
exports.PROPERTY_TYPES = {
    APARTMENT: 'apartment',
    HOUSE: 'house',
    COMMERCIAL: 'commercial',
};
exports.POST_STATUSES = {
    PUBLISHED: 'published',
    SUSPENDED: 'suspended',
    DRAFT: 'draft',
    PENDING: 'pending',
};
exports.PROFILE_LINKS = [
    {
        key: 'announcements',
        title: 'PROFILE.MY_ANNOUNCEMENTS',
        url: 'account/announcements',
        icon: 'icon-my-annoucements',
    },
    {
        key: 'wishlist',
        title: 'PROFILE.WISHLIST',
        url: 'account/wishlist',
        icon: 'icon-favorites',
        span: '',
    },
    {
        key: 'saved-searches',
        title: 'PROFILE.SAVED_SEARCHES',
        url: 'account/saved-searches',
        icon: 'icon-search',
    },
    {
        key: 'settings',
        title: 'PROFILE.SETTINGS',
        url: 'account/settings',
        icon: 'icon-settings',
    },
    {
        key: 'logout',
        title: 'PROFILE.LOGOUT',
        url: 'account/logout',
        icon: 'icon-logout',
    },
];
exports.MEDIA_TYPES = {
    IMAGE: 1,
    DOCUMENT: 2,
    VIDEO: 3,
    TOUR_3D: 4,
    FLOOR_PLAN: 5,
    APARTMENT_PLAN: 6,
    BUILDING_PLAN: 7,
};
exports.BUILDING_MEDIA_TYPES = {
    BUILDING_PICTURES: 1,
    BUILDING_VIDEOS: 2,
    BUILDING_PERMIT: 3,
    BUILDING_GENERAL_PLAN: 4,
};
exports.CURRENCIES = {
    '051': 'AMD',
    '840': 'USD',
    '643': 'RUB',
};
exports.DATE_FORMAT = {
    READABLE_DATE: 'DD MMM, YYYY',
};
exports.PREVIEW_URL = {
    preview: '/',
    wishList: '/account/wishlist/preview/',
    announcements: '/account/announcements/preview/',
};
exports.ONLY_LATIN_ALPHABET_EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
